var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationRead({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7277 7.47595C16.7277 8.85747 17.0929 9.67176 17.8964 10.6101C18.5054 11.3014 18.7 12.1889 18.7 13.1516C18.7 14.1132 18.384 15.0261 17.751 15.7673C16.9223 16.6558 15.7537 17.223 14.5609 17.3216C12.8325 17.469 11.103 17.5931 9.35053 17.5931C7.59696 17.5931 5.86854 17.5189 4.14012 17.3216C2.9463 17.223 1.77762 16.6558 0.95003 15.7673C0.317041 15.0261 0 14.1132 0 13.1516C0 12.1889 0.195691 11.3014 0.803535 10.6101C1.63222 9.67176 1.97331 8.85747 1.97331 7.47595V7.00732C1.97331 5.15717 2.43466 3.94736 3.38469 2.76304C4.79716 1.03586 7.06127 0 9.30133 0H9.39972C11.6879 0 14.0252 1.08572 15.4137 2.88713C16.3145 4.04707 16.7277 5.20591 16.7277 7.00732V7.47595ZM6.13093 19.867C6.13093 19.313 6.63929 19.0593 7.10939 18.9508C7.65929 18.8344 11.0101 18.8344 11.56 18.9508C12.0301 19.0593 12.5384 19.313 12.5384 19.867C12.5111 20.3943 12.2017 20.8619 11.7743 21.1588C11.22 21.5908 10.5695 21.8645 9.88951 21.9631C9.51343 22.0118 9.14392 22.0129 8.78096 21.9631C8.09987 21.8645 7.44938 21.5908 6.8962 21.1577C6.46765 20.8619 6.15826 20.3943 6.13093 19.867Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationRead);
export default __webpack_public_path__ + "static/media/notification_read.fe0bb58685c80412c2cb766a9e1e86a6.svg";
export { ForwardRef as ReactComponent };